module.exports = __webpack_public_path__ + "img/59.816c064b.jpg";